import Typography from "@mui/material/Typography";

export const NotFoundPage = () => {
  return <Typography>404</Typography>;
};
